module.exports = __webpack_public_path__ + "img/interface-dark.bedb7336.svg";